// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ShaderPresetPickerContract = contract({
  name: "ShaderPresetPicker",
  description: "Runtime gallery of shader presets — click to select. Use with ThreeScene as a controlled input so the user can pick a background shader. For a single preview card, use ShaderPresetPreview directly.",
  import: "@gradeui/ui",
  aliases: ["shader picker","preset picker","shader gallery","preset gallery"],
  composesWith: ["ShaderPresetPreview (internal)","ThreeScene (the typical downstream consumer)"],
  styleDefaults: {"ShaderPresetPicker":"grid grid-cols-2 gap-3"},
  props: {
  "value": {
      schema: z.string().optional(),
      design: "content",
      description: "currently selected preset id (controlled)",
  },
  "onChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "called when the user clicks a preset card",
  },
  "filterTags": {
      schema: z.string().optional(),
      design: "content",
      description: "only show presets matching at least one tag (\"space\" | \"retro\" | \"motion\" | \"hero\" | \"background\" …)",
  },
  "live": {
      schema: z.enum(["never", "hover", "always"]).optional(),
      design: "knob",
      description: "thumbnail render mode",
      default: "hover",
  },
  "postPreset": {
      schema: z.string().optional(),
      design: "content",
      description: "shared post-FX preset applied to every thumbnail",
  },
  "palette": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "shared palette applied to every thumbnail",
  },
  "columns": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "grid columns at md+ breakpoint",
  },
  },
});
